import { IMainController } from '@ambire-common/interfaces/main'
import useController from '@common/hooks/useController'

// Native: bypass MainControllerStateProvider (web-only); source state directly
// from the in-process ControllerStore via useController.
export default function useMainControllerState(): IMainController {
  const { state } = useController('MainController')
  return state as IMainController
}
